import CurrencyFormatter from "currency-formatter";

export default class GeneralHelper {
  /**
   * This method can be used to get the sum of an attribute from an array of objects. In case the applyCurrentFormat is
   * set to true, it will return the sum formatted for USD number format.
   *
   * @param {array<object>} array
   * @param {string} objectKey
   * @param {object} options
   * @returns {number|*}
   */
  static sumObjectAttributeFromArray(array, objectKey, options = { applyCurrencyFormat: false }) {
    if (array.length === 0) return 0

    const sumResult = array.reduce((acc, obj) => acc + obj[objectKey], 0)
    if (options.applyCurrencyFormat) {
      return CurrencyFormatter.format(sumResult, { code: "USD", symbol: "$ " })
    }

    return sumResult
  }

  static convertArrayToKeyAndValueObject(array, objectKey, objectValue) {
    return array.reduce((acc, item) => {
      acc[item[objectKey]] = item[objectValue]

      return acc
    }, {})
  }

  static calculateTotalByYear(data) {
    const yearTotalMap = {};

    for (const item of data) {
      const dateParts = item.date.split('-'); // Split by hyphen
      const year = dateParts[0];
      const value = parseFloat(item.value);

      if (!isNaN(value)) {
        if (!yearTotalMap[year]) {
          yearTotalMap[year] = 0;
        }
        yearTotalMap[year] += value;
      }
    }

    return Object.entries(yearTotalMap).map(([year, value]) => ({
      year,
      value
    })).reverse();
  }
}
